module.exports = __webpack_public_path__ + "9477ff6a0643b78a6d15939ba64ff75f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-18.png
// module id = 1632
// module chunks = 0